<template>
  <div class="fan fan-component f-plugin-ba-list">
    <f-layout ref="flayout"
              :superPage="page"
              :superApi="superApi"
              @reloadData="reloadData">
      <template #subHeadLeft>
        <f-search :superFilter="filter"
                  :superColumns="superColumns"
                  @change="handleSearch"
                  @reloadData="reloadData" />
      </template>
      <template #subHeadRight>
        <a-button-group>
          <a-button @click="reloadData"><template #icon><icon-refresh /></template>刷新</a-button>
          <a-button type="primary" @click="$refs.flayout.bindOpenCurd('新增')">
            <template #icon><icon-plus /></template>新增
          </a-button>
        </a-button-group>
      </template>
      <template #body>
        <a-spin :loading="loading" tip="加载中...">
          <div class="card-grid">
            <div v-for="item in dataList" :key="item.id" class="device-card" @click="handleView(item)">
              <div class="card-header">
                <span class="device-name">{{ getFieldValue(item, titleField) || item.name || '-' }}</span>
              </div>
              <div class="card-body">
                <div class="device-image" v-if="imageField">
                  <img v-if="getFieldValue(item, imageField)" :src="getFieldValue(item, imageField)" alt="" />
                  <div v-else class="no-image"><icon-robot style="font-size: 48px; color: #c9cdd4" /></div>
                </div>
                <div class="device-info" :class="{ 'full-width': !imageField }">
                  <div v-for="col in infoColumns" :key="col.dataIndex" class="info-row">
                    <span class="label">{{ col.title }}：</span>
                    <span class="value">
                      <template v-if="col.form === 'price' || col.dataIndex === 'price'">
                        <span style="color:#f53f3f;font-weight:700;">¥{{ getDisplayValue(item, col) }}</span>
                      </template>
                      <template v-else>{{ getDisplayValue(item, col) }}<template v-if="col.unit"> {{ col.unit }}</template></template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-actions" v-if="$slots.customAction" @click.stop>
                <slot name="customAction" :record="item"></slot>
              </div>
            </div>
          </div>
        </a-spin>
        <div class="pagination-wrap">
          <a-pagination :total="total" :page-size="filter.limit" :current="filter.page"
                        :page-size-options="[8, 12, 16, 24]"
                        show-total show-page-size
                        @change="handlePageChange" @page-size-change="handleSizeChange" />
        </div>
      </template>
    </f-layout>
  </div>
</template>

<script>
export default {
  name: 'FPluginBaList',
  props: {
    superTitle: { type: String, default: '' },
    superApi: { type: String, default: '' },
    superColumns: { type: Array, default: () => [] }
  },
  data() {
    return { page: {}, loading: false, dataList: [], total: 0, filter: {} }
  },
  computed: {
    titleField() {
      const col = this.superColumns.find(c =>
        c.dataIndex && c.dataIndex !== 'id' && c.key !== 'action' &&
        (!c.hidden || !c.hidden.includes('list'))
      )
      return col ? col.dataIndex : 'name'
    },
    imageField() {
      const col = this.superColumns.find(c => c.form === 'image' || c.form === 'upload' || c.form === 'images')
      return col ? col.dataIndex : ''
    },
    infoColumns() {
      return this.superColumns.filter(c => {
        if (!c.dataIndex) return false
        if (c.form === 'hidden') return false
        if (c.key === 'action') return false
        if (c.dataIndex === this.titleField) return false
        if (c.dataIndex === this.imageField) return false
        return true
      })
    }
  },
  mounted() { this.initPage() },
  activated() { this.initPage() },
  methods: {
    async initPage() {
      this.filter = { page: 1, limit: 12 }
      this.page = this.$fan.utils.parse({ loading: false, initing: false })
      this.$store.state.page.columns = {}
      this.$store.state.page.tableColumns = []
      this.$store.state.page.keyinfo = {}
      if (this.superColumns.length > 0) {
        await this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      }
      if (this.superApi) this.loadData()
    },
    handleSearch(changes = {}) { this.filter = { ...this.filter, ...changes, page: 1 }; this.loadData() },
    handlePageChange(page) { this.filter.page = page; this.loadData() },
    handleSizeChange(size) { this.filter.limit = size; this.filter.page = 1; this.loadData() },
    async loadData() {
      if (!this.superApi) return
      this.loading = true
      try {
        const params = { ...this.filter }
        const res = await this.$fan.api.get(this.superApi, params)
        if (res && res.status === 0) {
          this.dataList = (res.data && res.data.data) ? res.data.data : []
          this.total = Number(res.data?.count) || 0
        }
      } catch {} finally { this.loading = false }
    },
    reloadData() { this.filter = { page: 1, limit: 12 }; this.loadData() },
    getFieldValue(obj, path) {
      if (!obj || !path) return undefined
      const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.')
      let val = obj
      for (const k of keys) { if (val == null) return undefined; val = val[k] }
      return val
    },
    getDisplayValue(item, col) {
      const raw = this.getFieldValue(item, col.dataIndex)
      if (raw == null || raw === '') return '-'
      if (['select', 'radio', 'cascader', 'selectMultiple'].includes(col.form)) {
        const keyinfo = this.$store.state.page?.keyinfo || {}
        const optMap = keyinfo[col.dataIndex]
        if (optMap && optMap[raw] && optMap[raw].name) return optMap[raw].name
        if (optMap && optMap[String(raw)] && optMap[String(raw)].name) return optMap[String(raw)].name
        if (typeof raw === 'string' && raw.includes(',')) {
          return raw.split(',').map(v => {
            const k = v.trim()
            if (optMap && optMap[k] && optMap[k].name) return optMap[k].name
            return k
          }).join(', ')
        }
      }
      return raw
    },
    async handleView(record) {
      await this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      const cols = this.$store.state.page.columns || {}
      const flat = { ...record }
      this.superColumns.forEach(col => {
        if (!col.dataIndex) return
        if (col.dataIndex.includes('[') || col.dataIndex.includes('.')) {
          let val = this.getFieldValue(record, col.dataIndex)
          if (['select', 'radio', 'cascader'].includes(col.form)) {
            val = this.getDisplayValue(record, col)
            if (cols && cols[col.dataIndex]) cols[col.dataIndex].form = 'input'
          }
          if (col.unit && val != null && val !== '-') val = val + ' ' + col.unit
          flat[col.dataIndex] = val
        }
      })
      this.$refs.flayout.bindOpenCurd('详情', { record: flat })
    }
  }
}
</script>

<style scoped lang="less">
.f-plugin-ba-list {
  height: 100%; display: flex; flex-direction: column;
  :deep(.f-layout-content), :deep(.f-layout-level2), :deep(.main), :deep(.mainBody),
  :deep(.mainContent), :deep(.content), :deep(.contentBody) {
    height: 100%; display: flex; flex-direction: column;
  }
  :deep(.contentBody) > div { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
}
.card-grid {
  flex: 1; display: grid; grid-template-columns: repeat(4, 1fr);
  gap: 16px; overflow-y: auto; padding-right: 8px; align-content: start;
}
.device-card {
  background: #fff; border: 1px solid #e5e6eb; border-radius: 8px;
  padding: 16px; cursor: pointer; transition: all 0.2s;
  &:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-color: #165dff; }
}
.card-header { margin-bottom: 12px; .device-name { font-size: 16px; font-weight: 600; color: #1d2129; } }
.card-body { display: flex; gap: 16px; }
.card-actions { margin-top: 12px; padding-top: 10px; border-top: 1px solid #f0f1f3; display: flex; gap: 8px; flex-wrap: wrap; }
.device-image {
  width: 120px; height: 100px; flex-shrink: 0; background: #f7f8fa;
  border-radius: 4px; display: flex; align-items: center; justify-content: center; overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; }
  .no-image { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; }
}
.device-info { flex: 1; display: flex; flex-direction: column; gap: 8px; font-size: 13px; &.full-width { gap: 6px; } }
.info-row { display: flex; .label { color: #86909c; min-width: 70px; flex-shrink: 0; } .value { flex: 1; color: #1d2129; } }
.pagination-wrap { margin-top: 16px; text-align: right; flex-shrink: 0; }
@media (max-width: 1400px) { .card-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 992px) { .card-grid { grid-template-columns: repeat(2, 1fr); } }
</style>
